export default function responsibleKindShipList(t) {
  return [
    {
      value: 'M',
      label: t('responsible.mother'),
    },
    {
      value: 'P',
      label: t('responsible.father'),
    },
    {
      value: 'I',
      label: t('responsible.sibling'),
    },
    {
      value: 'A',
      label: t('responsible.grandparents'),
    },
    {
      value: 'T',
      label: t('responsible.uncleOrAunt'),
    },
    {
      value: 'R',
      label: t('responsible.cousin'),
    },
    {
      value: 'B',
      label: t('responsible.babysitter'),
    },
    {
      value: 'O',
      label: t('responsible.driver'),
    },
    {
      value: 'U',
      label: t('responsible.other'),
    },
  ];
}
